import { asEnumType, asObjectType } from '@gqloom/zod'
import { z } from 'zod'

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const paginationInputSchema = z
  .object({
    page: z.number().optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    cursor: z.string().optional(),
    pageSize: z.number().optional(),
  })
  .register(asObjectType, {
    name: 'PaginationInput',
  })

export const sortDirectionEnumSchema = z.enum(SortDirection).register(asEnumType, {
  name: 'SortDirection',
})

// Base page info object schema (not registered - each file registers with unique name)
export const basePageInfoSchema = z.object({
  startCursor: z.string().optional(),
  endCursor: z.string().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  totalRecords: z.number(),
})
